module.exports = __webpack_public_path__ + "static/media/my_cart_english.aa448b50.png";